import { useQuery } from '@tanstack/react-query';

import { type ClassStudent } from '~entities/student/modal/class-student';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetStudentsByClassIdParams {
  classId: string;
}

export const getStudentsByClassIdAPI = async (
  params: GetStudentsByClassIdParams,
) => {
  const response = await baseAPI.get<Array<ClassStudent>>(
    `/students/${params.classId}/class`,
  );
  return response.data;
};

export const getStudentsByClassIdOptions = (
  params: GetStudentsByClassIdParams,
) => ({
  queryKey: [KEYS.STUDENTS, params.classId],
  queryFn: () => getStudentsByClassIdAPI(params),
});

export const useGetStudentsByClassId = (params: GetStudentsByClassIdParams) => {
  return useQuery(getStudentsByClassIdOptions(params));
};
